const { ORGANISATION_DOMAIN_DUPLICITY, USER_EMAIL_DUPLICITY } = require('./codes/errorCodes');
const {
    INVALID_PROMO_VOUCHER_CODE,
    PROMO_CODE_ALREADY_USED,
    PROMO_CODE_NOT_FOR_LECTURE,
    PROMO_CODE_NOT_FOR_WORKSHOP,
    PROMO_CODE_NOT_FOR_COURSE,
    PROMO_CODE_NOT_FOR_BUNDLE,
} = require('./handledApiErrors');

/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    [ORGANISATION_DOMAIN_DUPLICITY.code]: {
        code: ORGANISATION_DOMAIN_DUPLICITY.code,
        description: 'Office with requested domain name already exists.',
    },
    [USER_EMAIL_DUPLICITY.code]: {
        code: USER_EMAIL_DUPLICITY.code,
        description: 'User with requested email already exists.',
    },
    [INVALID_PROMO_VOUCHER_CODE.code]: {
        code: INVALID_PROMO_VOUCHER_CODE.code,
        description: 'Promo code is not yet valid, does not exist or expired',
    },
    [PROMO_CODE_ALREADY_USED.code]: {
        code: PROMO_CODE_ALREADY_USED.code,
        description: 'Promo code already used by user.',
    },
    [PROMO_CODE_NOT_FOR_LECTURE.code]: {
        code: PROMO_CODE_NOT_FOR_LECTURE.code,
        description: 'promo code not for lecture',
    },
    [PROMO_CODE_NOT_FOR_WORKSHOP.code]: {
        code: PROMO_CODE_NOT_FOR_WORKSHOP.code,
        description: 'promo code not for workshop',
    },
    [PROMO_CODE_NOT_FOR_COURSE.code]: {
        code: PROMO_CODE_NOT_FOR_COURSE.code,
        description: 'promo code not for courses',
    },
    [PROMO_CODE_NOT_FOR_BUNDLE.code]: {
        code: PROMO_CODE_NOT_FOR_BUNDLE.code,
        description: 'promo code not for bundles',
    },
};
